import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-image-export-optimizer/dist/ExportedImage.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
